import React from "react";
import {
  Box,
  IconButton,
  Modal,
  Stack,
  Typography,
  Avatar,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useLanguages } from "../../context/LanguagesContext";

interface LanguageChooserProps {
  open: boolean;
  onClose: () => void;
}

export const LanguageChooser: React.FC<LanguageChooserProps> = ({
  open,
  onClose,
}) => {
  const { languages, dispatch } = useLanguages();

  const handleLanguageSelect = (languageCode: string) => {
    dispatch({ type: "SET_SELECTED_LANGUAGE", payload: languageCode });
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          maxHeight: "90vh",
          overflowY: "auto",
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          p: 2,
          width: { xs: "90%", sm: 400 },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            pb: 2,
            borderBottom: 1,
            borderColor: "divider",
          }}
        >
          <Box sx={{ width: 40 }} />
          <Typography variant="h6">Select a language</Typography>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>

        <Stack spacing={1} sx={{ mt: 2 }}>
          {languages.languages.map((lang) => {
            const isSelected = languages.selectedLanguage === lang.langugageCode;
            return (
              <Stack
                key={lang.langugageCode}
                onClick={() => handleLanguageSelect(lang.langugageCode)}
                direction="row"
                spacing={2}
                alignItems="center"
                sx={{
                  p: 1.5,
                  borderRadius: 1,
                  cursor: "pointer",
                  bgcolor: isSelected ? "action.selected" : "transparent",
                  "&:hover": {
                    bgcolor: "action.hover",
                  },
                  transition: "background-color 0.2s",
                }}
              >
                <Avatar
                  src={lang.flag}
                  alt={lang.name}
                  sx={{
                    width: 30,
                    height: 30,
                    border: 1,
                    borderColor: "divider",
                  }}
                />
                <Typography
                  sx={{
                    flex: 1,
                    fontWeight: isSelected ? 600 : 400,
                    color: isSelected ? "primary.main" : "text.primary",
                  }}
                >
                  {lang.name}
                </Typography>
              </Stack>
            );
          })}
        </Stack>
      </Box>
    </Modal>
  );
};

